import React, { useState, useRef, useCallback } from 'react';


export default function SIFDefinitions() {


  return (
    <div>
    <h4 className="">Definitions</h4>
    <div className="row py-2">
      <div className="col-12 col-sm-12 col-md-6 pt-2">
        <div className={'dx-card definition-card'}>
          <figure>
            <blockquote className="blockquote">
              <p>Potential Serious Injury or Fatality (SIF)</p>
            </blockquote>
            <figcaption className="blockquote-footer">
              A Potential Serious Injury or Fatal event is an incident or near miss
              that had the potential to produce a fatal, life-altering or life-threatening
              injury or ilness.
            </figcaption>
          </figure>
        </div>
      </div>
      <div className="col-12 col-sm-12 col-md-6 pt-2">
        <div className={'dx-card definition-card'}>
          <figure>
            <blockquote className="blockquote">
              <p>Actual Serious Injury or Fatality (SIF)</p>
            </blockquote>
            <figcaption className="blockquote-footer">
              An Actual Serious Injury or Fatal event is an incident that results in a
              fatal, life-altering or life-threatening injury or ilness.
            </figcaption>
          </figure>
        </div>
      </div>
      <div className="col-12 col-sm-12 col-md-6 pt-2">
        <div className={'dx-card definition-card'}>
          <figure>
            <blockquote className="blockquote">
              <p>Life-altering Injury or Illness</p>
            </blockquote>
            <figcaption className="blockquote-footer">
              Life-altering Injuries or Illnesses result in the loss of a body part
              (any bone loss), organ function or otherwise permanently disables that
              person's normal life.
            </figcaption>
          </figure>
        </div>
      </div>
      <div className="col-12 col-sm-12 col-md-6 pt-2">
        <div className={'dx-card definition-card'}>
          <figure>
            <blockquote className="blockquote">
              <p>Life-threatening Injury or Illness</p>
            </blockquote>
            <figcaption className="blockquote-footer">
              Life-threatening Injuries or Illnesses require immediate intervention
              to provide life-sustaining support.
            </figcaption>
          </figure>
        </div>
      </div>
    </div>

    </div>
  );
}
